import { CompanyStatus } from '@/types/enums/company-status';
import type { ApiCompany } from '@/types/api';
import type { CompanyWorkingHours } from '@/types/domain/company-working-hours';
import type { Company } from '@/types/domain/company';
import { getCompanyOpenStatus, groupCompanyWorkingHours, type CompanyOpenStatus } from './working-hours';

export interface CompanyStatusBadge {
  label: string;
  tone: 'success' | 'warning' | 'muted';
}

type CompanyStatusSource = Pick<Company, 'status'> | null | undefined;

export function canCompanyAcceptBookings(company?: CompanyStatusSource) {
  return company?.status === CompanyStatus.ACTIVE;
}

export function shouldFetchCompanyDetailsForCard(company: Pick<ApiCompany, 'status' | 'workingHours'>) {
  return canCompanyAcceptBookings(company) && company.workingHours == null;
}

export function resolveCompanyOpenStatus(
  company: CompanyStatusSource,
  workingHours: CompanyWorkingHours[] | undefined,
  currentDateTime: Date,
): CompanyOpenStatus | undefined {
  if (!canCompanyAcceptBookings(company) || !workingHours?.length) {
    return undefined;
  }

  return getCompanyOpenStatus(groupCompanyWorkingHours(workingHours), currentDateTime);
}

export function buildCompanyStatusBadge(
  company: CompanyStatusSource,
  openStatus?: CompanyOpenStatus,
): CompanyStatusBadge | undefined {
  if (!canCompanyAcceptBookings(company)) {
    return {
      label: 'Em breve',
      tone: 'warning',
    };
  }

  if (!openStatus) {
    return undefined;
  }

  return {
    label: openStatus.isOpen ? 'Aberto agora' : 'Fechado',
    tone: openStatus.isOpen ? 'success' : 'muted',
  };
}
